<template>
  <BaseCard
    :closable="isExpanded && !onlyResource && removable"
    noPadding
    @close="$emit('delete')"
  >
    <EditableContent
      v-show="isExpanded"
      :part="part"
      :partIndexes="partIndexes"
      :onlyResource="onlyResource"
      :servicePackage="servicePackage"
      v-test="'appointment-part-expanded'"
    />
    <component
      :is="servicePackage ? CollapsedPackage : CollapsedService"
      v-show="!isExpanded"
      :part="part"
      :partIndexes="partIndexes"
      :servicePackage="servicePackage"
      @click="$emit('expand')"
      v-test="'appointment-part-collapsed'"
    />
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useCreateAppointmentStore } from '@/stores/calendar-create-appointment';
import type { AppointmentPartAttributes, ServicePackage } from '@/types';
import CollapsedPackage from './collapsed/Package.vue';
import CollapsedService from './collapsed/Service.vue';
import EditableContent from './content/index.vue';

const props = withDefaults(
  defineProps<{
    part: AppointmentPartAttributes;
    isExpanded: boolean;
    partIndexes: number[];
    servicePackage?: ServicePackage;
    removable: boolean;
  }>(),
  {
    part: () => ({}),
    isExpanded: false,
    removable: true,
  },
);

defineEmits<{
  (e: 'expand'): void;
  (e: 'delete'): void;
}>();

const { existingAppointmentData } = storeToRefs(useCreateAppointmentStore());
const onlyResource = computed(
  () => existingAppointmentData.value?.treatwell ?? false,
);
</script>
